import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateDevicePeripheralAPI = async (rowData, t, successfulText) => {
  await axios({
    url: `/api/v2/command/device-peripheral-update-send`,
    method: "POST",
    data: {
      id: rowData.id,
      device_id: rowData.device_id,
      execute_type: "device_peripheral_update",
      peripheral_type: rowData.firmware.peripheral_type.name,
      file_name: rowData.firmware.name,
      file_path: rowData.firmware.file,
      md5: rowData.firmware.md5
    }
  });
  successHandling(t, successfulText);
  return true;
};
